import { Component } from '@angular/core';
import { IonicPage, NavParams, ToastController, NavController, LoadingController } from 'ionic-angular';

import { WorkflowApproval, GlobalVarApproval } from '@providers/index';

@IonicPage()
@Component({
  selector: 'page-chronology',
  templateUrl: 'chronology.html'
})
export class ChronologyPage {
  records = [];
  task:any;

  constructor(
    public navCtrl: NavController,
     public workflow: WorkflowApproval,
     public globalvar:GlobalVarApproval,
     public toastCtrl: ToastController,
     public loadingCtrl: LoadingController,
     public navParams: NavParams
    ) {
      
      this.task = navParams.get('task');
      console.log(this.task);
  }

  doRefresh(refresher) {
    refresher.complete();
    this.get_data();
  }

  get_data(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      Workflow_ID : this.task.Workflow_ID,
      Transaction_ID : this.task.Transaction_ID
    };
    this.workflow.get_chronology(params).subscribe((resp:any) => {
      this.records = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }



  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    if(this.task){
      this.get_data();
    }
  }
 
  /**
   * Navigate to the detail page for this item.
   */
  selectWF(workflow) {
    this.navCtrl.push('ListTaskPage', {
      workflow: workflow,
      is_mytask: 0
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/chronology/chronology.ts